const state = {
    enabled: false,
    siteKey: null
};

const getters = {
    enabled: state => state.enabled,
    siteKey: state => state.siteKey,
};

const actions = {
};

const mutations = {
    enabled(state, val) {
        state.enabled = val;
    },
    siteKey(state, val) {
        state.siteKey = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
